import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ListLoader from "../../../CustomComponents/AllLoader/ListLoader";
import OrderPostPagination from "../../FindWork/SearchAll/AllPosts/CustomPagination/OrderPostPagination";
import { getMyOrderContestList } from "../../../../redux/contest/action";
import {
  getMemberSince,
  getRemaindays,
} from "../../../Common/AllDateTimeReleventFormate";
import LabelgetRemaindays from "../../../Common/CustomeLabel/LabelgetRemaindays";
import CustomeDeadlineDateLabel from "../../../Common/CustomeLabel/CustomeDeadlineDateLabel";
import { decodeHtml } from "../../../../assests/extention/commonfunction";

export default function PaginationforConstestActive() {
  const path = "Assets/scss/myorders.module.scss";
  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(0);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const myordercontestlist = useSelector(
    ({ contest: { myordercontestlist } }) => myordercontestlist,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getMyOrderContestList(2, pageNumber, 10, 11));
  }, [pageNumber]);

  return (
    <div className="order-tabs">
      <div className="tab-content">
        <div className="posted-project">
          {Array.isArray(myordercontestlist?.response) && (
            <>
              <h4>
                Recent Posted Win business Opportunities (WBO)
                <OrderPostPagination
                  totalitemcounts={myordercontestlist?.count}
                  size={10}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                />
              </h4>
              {myordercontestlist?.length == 0 && <ListLoader />}
              <div className="recent-post">
                {myordercontestlist?.response.map((item, index) => (
                  <div key={index} className="post-back">
                    <div className="col-md-5 ">
                      <h3>{decodeHtml(item?.title)}</h3>
                      <div className="post-img">
                        <CustomeDeadlineDateLabel
                          type={item?.type}
                          last_date={item?.last_date}
                        />
                        <LabelgetRemaindays last_date={item?.last_date} />
                      </div>
                    </div>
                    <div className="activity col-md-4">
                      <h6>Activity</h6>
                      <div className="post-img">
                        <p>
                          <img
                            src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                            alt=""
                          />
                          Entries: {item?.proposal_count}
                        </p>
                      </div>
                    </div>
                    <button
                      onClick={() =>
                        navigate(
                          `/${lan}/dashboard/myorders/contest/active/${item.id}`,
                        )
                      }
                      className="btn"
                    >
                      View details
                      <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                        alt=""
                      />
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
